<!--
  TypeElement.vue
  The type chip of @auger/ui. A bare type name is resolved through the app's
  types store to the type the package's chip reads its label and icon from.
-->
<template>
  <TypeElement :value="type" :size="size" />
</template>

<script setup lang="ts">
import { computed } from "vue"
import TypeElement from "@auger/ui/components/elements/TypeElement.vue"
import type { RecordType } from "@/stores/types"
import { getType } from "@/stores/types"

const props = withDefaults(
  defineProps<{
    value: RecordType | string
    size?: string
  }>(),
  { size: "normal" }
)

const type = computed(() => {
  if (typeof props.value !== "string") return props.value
  return getType(props.value) ?? props.value
})
</script>
